var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0595 13.2213C18.3182 7.96259 24.6195 5.33325 31.9635 5.33325C39.3075 5.33325 45.5875 7.94392 50.8035 13.1599C56.0195 18.3759 58.6302 24.6559 58.6302 31.9999C58.6302 39.3439 56.0195 45.6239 50.8035 50.8399C45.5875 56.0559 39.3075 58.6666 31.9635 58.6666C24.6195 58.6666 18.3369 56.0559 13.1209 50.8399C7.90488 45.6239 5.29688 39.3439 5.29688 31.9999C5.29688 24.6559 7.88621 18.3946 13.0595 13.2213ZM26.5875 48.0426L50.5875 24.0426L46.8382 20.1653L26.5875 40.4159L17.0889 30.9173L13.3369 34.6666L26.5875 48.0426Z",
    fill: "#05B20B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tick-icon.64d7d4c8c63f49f119489ca03c41fdf4.svg";
export { ForwardRef as ReactComponent };